export const states = {
    Pending: "Pending",
    Accepted: "Accepted",
  };
  
export const translate = {
    Pending: "Pendiente",
    Accepted: "Aceptado",
};

export const select = Object.keys(states)
  .map(state => ({ value: state, label: translate[state] }));